import styled from 'styled-components'

export const ComunicacoesBox = styled.div`

`

ComunicacoesBox.PrintHeader = styled.div`
    font-size: 12px;
    width: -webkit-fill-available;
    display: table;
    background-color: #e3e0e0;
    text-align: center;
    border: solid 3px;
    border-color: #000000;
`

ComunicacoesBox.PrintColumn = styled.div`
    display: table-cell; 
    padding: 0 5px 0 5px;
    min-width: 95px;
    max-width: 95px;
`

ComunicacoesBox.PrintColumnComunicacao = styled.div`
    display: table-cell; 
    padding: 0 5px 0 5px;
    min-width: 85px;
    max-width: 85px;
`

ComunicacoesBox.PrintColumnDestinatario = styled.div`
    display: table-cell; 
    padding: 0 5px 0 5px;
    min-width: 90px;
    max-width: 90px;
`

ComunicacoesBox.PrintColumnProcesso = styled.div`
    display: table-cell; 
    padding: 0 5px 0 5px;
    min-width: 100px;
    max-width: 100px;
`

ComunicacoesBox.PrintBody = styled.div`
    font-size: 10px;
    background-color: #ffffff;
    text-align: center;
    border: solid 3px;
    border-color: #000000;
`

ComunicacoesBox.PrintBodyLine = styled.div`
    width: -webkit-fill-available;
    display: table;    
`

ComunicacoesBox.Paginacao = styled.div`
    text-align: center;
    padding-bottom: 30px;
    padding-top: 10px;
`

ComunicacoesBox.Exportacao = styled.div`
    display: inline-flex;
    position: relative;
    left: 16%;
`

ComunicacoesBox.ExportacaoAcao = styled.div`
    padding: 0 5px 0 5px
`

ComunicacoesBox.PrintPage = styled.div`
    padding: 0 5px 0 5px;
    
`